import {
	Alert,
	Box,
	Button,
	Chip,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	IconButton,
	Stack,
	Typography,
} from "@mui/material";
import { ClearRounded } from "@mui/icons-material";
import { DataGrid } from "@mui/x-data-grid";
import { grey } from "@mui/material/colors";
import { useMemo } from "react";

const BulkPublishModal = ({
	modal,
	setModal,
	previewStyles = [],
	selectAllFiltered = false,
	filterSummary = "",
	loading = false,
	onConfirm,
}) => {
	const columns = useMemo(
		() => [
			{ field: "style_id", headerName: "Style ID", width: 130, headerAlign: "center", align: "center" },
			{ field: "style_name", headerName: "Style Name", width: 160, headerAlign: "center", align: "center" },
			{ field: "season", headerName: "Season", width: 110, headerAlign: "center", align: "center" },
			{ field: "brand", headerName: "Brand", width: 140, headerAlign: "center", align: "center" },
			{ field: "category", headerName: "Category", width: 130, headerAlign: "center", align: "center" },
			{ field: "final_mrp", headerName: "Final MRP", width: 110, headerAlign: "center", align: "center" },
			{
				field: "has_sizes",
				headerName: "Sizes",
				width: 100,
				headerAlign: "center",
				align: "center",
				renderCell: ({ row }) => (
					<Chip
						size="small"
						label={row.has_sizes ? "Yes" : "Missing"}
						color={row.has_sizes ? "success" : "error"}
						variant="outlined"
					/>
				),
			},
		],
		[],
	);

	const invalidCount = previewStyles.filter(
		(row) => !row.has_sizes || row.final_mrp === "" || row.final_mrp == null || Number.isNaN(Number(row.final_mrp)),
	).length;

	const handleClose = () => {
		if (loading) return;
		setModal(false);
	};

	return (
		<Dialog open={modal} onClose={handleClose} maxWidth="lg" fullWidth>
			<DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
				<Typography variant="h6">Confirm Bulk Publish</Typography>
				<IconButton onClick={handleClose} disabled={loading}>
					<ClearRounded />
				</IconButton>
			</DialogTitle>
			<DialogContent>
				<Stack spacing={1.5}>
					<Alert severity="info">
						{selectAllFiltered
							? `Publishing all ${previewStyles.length} MRP_PENDING style(s) matching the current filter${
									filterSummary ? `: ${filterSummary}` : ""
							  }.`
							: `Publishing ${previewStyles.length} selected MRP_PENDING style(s).`}
					</Alert>
					{invalidCount > 0 && (
						<Alert severity="warning">
							{invalidCount} style(s) are missing sizes or Final MRP and cannot be published. Fix them before
							confirming.
						</Alert>
					)}
					<Box height="45vh">
						<DataGrid
							rows={previewStyles}
							columns={columns}
							getRowId={(row) => row.style_id}
							hideFooter
							disableColumnSelector
							disableRowSelectionOnClick
							sx={{
								border: "none",
								"& .MuiDataGrid-columnHeaders": {
									background: grey[300],
									borderRadius: 1,
								},
							}}
						/>
					</Box>
				</Stack>
			</DialogContent>
			<DialogActions sx={{ px: 3, pb: 2 }}>
				<Button variant="outlined" onClick={handleClose} disabled={loading}>
					Cancel
				</Button>
				<Button
					variant="contained"
					color="success"
					onClick={onConfirm}
					disabled={loading || previewStyles.length === 0 || invalidCount > 0}>
					Confirm Publish ({previewStyles.length})
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default BulkPublishModal;
